import React, { useState } from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import Category from './category'
import Location from './location'

import sceneLogic from '~/scenes/pages/request/logic'

const CategoryLocation = () => {
  const [showErrors, setShowErrors] = useState(false)
  const { nextPage } = useActions(sceneLogic)
  const { pageIsValid, category, location } = useValues(sceneLogic)

  const handleNextPage = () => {
    if (pageIsValid) {
      nextPage()
    } else {
      setShowErrors(true)
    }
  }

  return (
    <div className='list-choice'>
      <div>
        <h1>{I18n.t('react.request.category.title')}</h1>
        <Category />
        {showErrors && !category && <div className='simple-error'>{I18n.t('courses.form.error_field_empty')}</div>}
      </div>
      <div className='mt-40'>
        <h1>{I18n.t('react.request.location.title')}</h1>
        <Location />
        {showErrors && !location && <div className='simple-error'>{I18n.t('courses.form.error_field_empty')}</div>}
      </div>
      <div className='mt-40'>
        <button className={pageIsValid ? null : 'disabled'} onClick={handleNextPage}>
          {I18n.t('react.request.next')}
        </button>
      </div>
    </div>
  )
}

export default CategoryLocation
